import styled from 'styled-components';

export default styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    margin-top: 20px;
    bottom: 0px;
`